export const TYPE_BUILDING = 'building';
export const TYPE_CLIENT = 'client';
export const TYPE_USER = 'user';
export const TYPE_MARKETING_LEAD = 'marketingLead';
